import { useStore } from 'effector-react'
import { featureFlagModel } from '~/shared/lib/featureFlag'
import { ProgressBlock } from '~/shared/ui/Loaders'
import { DocumentBasedRegistrationPage } from './DocumentBasedRegistrationPage'
import { RegistrationPage } from './RegistrationPage'

export function RegistrationWrapperPage() {
  const featureFlags = useStore(featureFlagModel.$featureFlags)
  const featureFlagsPending = useStore(
    featureFlagModel.getFeatureFlagsFx.pending,
  )

  if (featureFlagsPending) {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ProgressBlock />
      </div>
    )
  }

  return featureFlags.document_based_registration ? (
    <DocumentBasedRegistrationPage />
  ) : (
    <RegistrationPage />
  )
}
